import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
var _excluded = ["message", "trace"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var M2ApiResponseError = /*#__PURE__*/function (_Error) {
  _inherits(M2ApiResponseError, _Error);

  var _super = _createSuper(M2ApiResponseError);

  function M2ApiResponseError(_ref) {
    var _this;

    var method = _ref.method,
        resourceUrl = _ref.resourceUrl,
        response = _ref.response,
        bodyText = _ref.bodyText;

    _classCallCheck(this, M2ApiResponseError);

    var body = "";
    var parsedBodyText;

    try {
      parsedBodyText = JSON.parse(bodyText);

      var _parsedBodyText = parsedBodyText,
          message = _parsedBodyText.message,
          trace = _parsedBodyText.trace,
          rest = _objectWithoutProperties(_parsedBodyText, _excluded);

      if (message) {
        body += "Message:\n\n  ".concat(message, "\n");
      }

      var addl = Object.entries(rest);

      if (addl.length > 0) {
        body += "\nAdditional info:\n\n".concat(JSON.stringify(rest, null, 4), "\n\n");
      }

      if (trace) {
        body += "Magento PHP stack trace: \n\n".concat(trace);
      }

      body += '\n';
    } catch (e) {
      body = bodyText;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, "".concat(method, " ").concat(resourceUrl, " responded ").concat(response.status, " ").concat(response.statusText, ": \n\n").concat(body)].concat(args));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), M2ApiResponseError);
    }

    _this.response = response;
    _this.method = method;
    _this.resourceUrl = resourceUrl; // Preserve the original error message.

    _this.baseMessage = parsedBodyText ? parsedBodyText.message : bodyText;
    return _this;
  }

  return _createClass(M2ApiResponseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { M2ApiResponseError as default };